import apiClient from './api';

export interface PLData {
  timeline: {
    revenue: { month: string; total: number }[];
    expenses: { month: string; total: number }[];
  };
  total_revenue: number;
  total_expenses: number;
}

export const dashboardService = {
  getCompanyPL: async (params: { start_date?: string; end_date?: string }): Promise<PLData> => {
    const response = await apiClient.get<PLData>('/accounting/pnl/', { params });
    return response.data;
  },
};